module.exports = __webpack_public_path__ + "img/bubbwax_alcorammswap.996ca46.png";